import { render, staticRenderFns } from "./SidebarMenuIcon.vue?vue&type=template&id=c68df0cc&"
import script from "./SidebarMenuIcon.vue?vue&type=script&lang=js&"
export * from "./SidebarMenuIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SidebarMenuIcon.vue"
export default component.exports